<template>
    <div v-if="$page.props.auth.logged_in" class="hidden md:flex md:items-center md:ms-6">
        <div class="ms-3 relative">
            <Dropdown align="right" width="48">
                <template #trigger>
                    <button
                        v-if="$page.props.jetstream.managesProfilePhotos"
                        class="flex text-sm border-2 border-transparent rounded-full focus:outline-hidden focus:border-gray-300 transition"
                    >
                        <img
                            :alt="$page.props.auth.user.name"
                            :src="$page.props.auth.user.profile_photo_url"
                            class="h-8 w-8 rounded-full object-cover"
                        />
                    </button>

                    <span v-else class="inline-flex rounded-md">
                                        <button
                                            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-hidden focus:bg-gray-50 active:bg-gray-50 transition ease-in-out duration-150"
                                            type="button"
                                        >
                                            {{ $page.props.auth.user.name }}

                                            <svg
                                                class="ms-2 -me-0.5 h-4 w-4"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="1.5"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </span>
                </template>

                <template #content>
                    <div class="block px-4 py-2 text-xs text-gray-400">Manage Account</div>

                    <DropdownLink :href="route('profile.show')"> Profile</DropdownLink>
                    <DropdownLink as="button" @click="openInTab(portalUrl)">
                        Portal
                    </DropdownLink>

                    <div class="border-t border-gray-200"/>

                    <form @submit.prevent="logout">
                        <DropdownLink as="button"> Log Out</DropdownLink>
                    </form>
                </template>
            </Dropdown>
        </div>
    </div>

    <li v-if="$page.props.auth.logged_in" class="w-full block md:hidden">
        <div class="px-3 py-2 text-white">
            <div class="font-medium text-base">{{ $page.props.auth.user.name }}</div>
            <div class="font-medium text-sm text-gray-400">{{ $page.props.auth.user.email }}</div>
        </div>
    </li>
    <li v-if="$page.props.auth.logged_in" class="w-full block md:hidden">
        <Link
            :href="route('profile.show')"
            class="block w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black"
        >
            Profile
        </Link>
    </li>
    <li v-if="$page.props.auth.logged_in" class="w-full block md:hidden">
        <button
            class="text-left w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black"
            @click="openInTab(portalUrl)"
        >
            Portal
        </button>
    </li>
    <li v-if="$page.props.auth.logged_in" class="w-full block md:hidden">
        <form @submit.prevent="logout">
            <button
                class="text-left w-full py-2 px-3 text-gray-100 rounded hover:bg-primary-600 hover:text-black"
                type="submit"
            >
                Log Out
            </button>
        </form>
    </li>
</template>

<script setup>
    import DropdownLink from "@/InertiaComponents/DropdownLink.vue";
    import Dropdown from "@/InertiaComponents/Dropdown.vue";
    import { Link, router, usePage } from "@inertiajs/vue3";

    const portalUrl = usePage().props.portal_url;


    const logout = () => {
        router.post(
            route("logout"),
            {},
            {
                onFinish: () => {
                    window.location.reload();
                },
            },
        );
    };

    const openInTab = (url) => {
        window.location.href = url;
    };
</script>

<style scoped>

</style>